export const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none"
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#cdcdcd" : "",
    ":active": {
      backgroundColor: state.isSelected ? "#cdcdcd" : "",

    },
    ":hover": {
      backgroundColor: state.isSelected ? "" : "#cdcdcd",

    }
  })
};
